export const findFolderParentId = (nodes, folderId, parentId = null) => {
  for (const node of nodes) {
    if (String(node.id) === String(folderId)) return parentId;
    const found = findFolderParentId(node.subFolders || [], folderId, node.id);
    if (found !== undefined) return found;
  }
  return undefined;
};
